export const footer_data = [
  {
    label: "footer.user.copyright",
    url: "",
  },
  {
    label: "footer.user.all_rights_reserved",
    url: "",
  },
  {
    label: "footer.user.privacy_policy",
    url: "https://www.rankspro.io/privacy",
  },
  {
    label: "footer.user.refund_policy",
    url: "https://www.rankspro.io/refund-policy",
  },
  {
    label: "footer.user.terms",
    url: "https://www.rankspro.io/terms",
  },
];
